/*
 * Spinder Design — productaanbevelingen met fallback
 * ---------------------------------------------------
 * Haalt eerst de aanbevelingen uit de Search & Discovery-app op
 * (intent=complementary, per product ingesteld in de app). Heeft een product
 * die niet, dan valt hij terug op de automatische 'gerelateerd'-aanbevelingen
 * (intent=related) — zodat de sectie nooit leeg is. Zelfde laad-patroon als
 * Dawn's product-recommendations (IntersectionObserver, sectie-render-fetch).
 */
(function () {
  'use strict';
  if (customElements.get('spinder-recommendations')) return;

  class SpinderRecommendations extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.observer = new IntersectionObserver(
        function (entries, observer) {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(self);
          self.load(self.dataset.url).then(function (ok) {
            if (!ok && self.dataset.fallbackUrl) self.load(self.dataset.fallbackUrl);
          });
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    load(url) {
      var self = this;
      return fetch(url + '&product_id=' + this.dataset.productId + '&section_id=' + this.dataset.sectionId)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var div = document.createElement('div');
          div.innerHTML = text;
          var el = div.querySelector('spinder-recommendations');
          if (el && el.innerHTML.trim().length) {
            self.innerHTML = el.innerHTML;
            self.classList.add('product-recommendations--loaded');
            return true;
          }
          return false;
        })
        .catch(function () { return false; });
    }
  }

  customElements.define('spinder-recommendations', SpinderRecommendations);
})();
